import React from 'react'
import { Button } from 'react-bootstrap'
import { AiOutlineRight } from 'react-icons/ai'
import { StoreContext } from '../../../context/store-context'
import { addToCart as addToCartStyle } from './add-to-cart.module.scss'

export function AddToCart({ variants, dataLayer, ...props }) {
  const { addVariantToCart, loading } = React.useContext(StoreContext)

  async function addToCart(e) {
    e.preventDefault()
    for (const variant of variants) {
      if (variant.quantity > 0) {
        // Check if window object is defined, then push ecommerce data to the data layer
        if (typeof window !== 'undefined') {
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push(dataLayer)
        }
        await addVariantToCart(variant.id, variant.quantity)
      }
    }
  }

  const isAvailable = variants.every((item) => {
    return item.available
  })

  return (
    <Button
      variant='primary'
      className={`btn-buy my-3 ${addToCartStyle}`}
      type='submit'
      aria-label='Add to Cart'
      onClick={addToCart}
      disabled={!isAvailable || loading}
      {...props}
    >
      {isAvailable ? 'Add to Cart' : 'Out of Stock'}
      <span className='icon d-none d-lg-block'>
        <AiOutlineRight />
      </span>
    </Button>
  )
}
